import React from 'react';
import styled from 'styled-components';
import { Grid, IconType } from 'ui-toolkit';
import BackgroundBar from './components/BackgroundBar';
import HighlightBar from './components/HighlightBar';
import ProgressMarker from './components/ProgressMarker';
import ProgressMarkers from './components/ProgressMarkers';
import ProgressStepText from './components/ProgressStepText';

export interface ProgressStepProps {
  heading: string;
  hideWhenInactive?: boolean | null;
  icon?: IconType | null;
  isCurrent?: boolean | null;
  subheading: string;
  subtext?: string | null;
}

export interface ProgressBarProps {
  items: ProgressStepProps[];
  position: number;
}

export const StyledProgressBar = styled.div`
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing5};
  position: relative;
`;

const ProgressStepWrapper = styled(Grid)`
  height: 64px;
`;

const ProgressBar: React.FC<ProgressBarProps> = ({ items, position }) => (
  <StyledProgressBar>
    <BackgroundBar steps={items.length}>
      <HighlightBar steps={items.length} position={position} />
      <ProgressMarkers>
        {items.map(({ hideWhenInactive, icon }, i) => (
          <ProgressMarker
            key={i}
            icon={icon}
            isCurrent={position === i}
            isHidden={(hideWhenInactive && position !== i) || (position > i && i > 0 && !icon)}
            isPast={position > i}
          />
        ))}
      </ProgressMarkers>
    </BackgroundBar>
    <ProgressStepWrapper columnCount={items.length}>
      {items.map(({ hideWhenInactive, ...stepProps }, i) => (
        <ProgressStepText
          key={i}
          isCurrent={i === position}
          isHidden={(hideWhenInactive && position !== i) || (position > i && i > 0 && !stepProps.icon)}
          {...stepProps}
        />
      ))}
    </ProgressStepWrapper>
  </StyledProgressBar>
);

export default ProgressBar;
